/**
 * P1 DEPLOY: Build version for deployment validation
 * 
 * Check this via /api/version or by inspecting window.__AME_BUILD__
 */

export const BUILD_INFO = {
  marker: '20260303_p1_deploy_405_oauth1_fix',
  timestamp: '2026-03-03T20:30:00Z',
  version: '1.0.0',
  features: {
    oauth1_only_x: true,
    white_screen_fix: true,
    test_post_405_fix: true,
    pillbutton_type_button: true,
    oauth_x_complete_route: true
  }
};

// Expose globally for easy debugging
if (typeof window !== 'undefined') {
  window.__AME_BUILD__ = BUILD_INFO;
}

export default BUILD_INFO;
